import { render, staticRenderFns } from "./DishesGroup.vue?vue&type=template&id=14f360ac&scoped=true"
import script from "./DishesGroup.vue?vue&type=script&lang=ts"
export * from "./DishesGroup.vue?vue&type=script&lang=ts"
import style0 from "./DishesGroup.vue?vue&type=style&index=0&id=14f360ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f360ac",
  null
  
)

export default component.exports